import { render, staticRenderFns } from "./check_by_photo.vue?vue&type=template&id=6ec78ac0&"
import script from "./check_by_photo.vue?vue&type=script&lang=js&"
export * from "./check_by_photo.vue?vue&type=script&lang=js&"
import style0 from "./check_by_photo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports